module.exports = __webpack_public_path__ + "statics/img/extract-cash-1181585a.png";


//////////////////
// WEBPACK FOOTER
// ./web/img/xhpopulrz/download/extract-cash.png
// module id = 1214
// module chunks = 143